import { faUndo, faXmark } from "@fortawesome/free-solid-svg-icons";
import cx from "classnames";
import type { FC } from "react";
import { Button, Col, Row } from "react-bootstrap";

import { Icon } from "src/components/fragments";
import { useAmendment } from "./AmendmentContext";

export interface AmendableChangeRowProps {
  name?: string;
  field: string;
  newValue?: string | number | null;
  oldValue?: string | number | null;
  showDiff?: boolean;
}

const AmendableChangeRow: FC<AmendableChangeRowProps> = ({
  name,
  field,
  newValue,
  oldValue,
  showDiff = false,
}) => {
  const { state, clearField, restoreField } = useAmendment();
  const isRemoved = state.removedFields.has(field);

  if (!name || (!newValue && !oldValue)) return null;

  return (
    <Row
      className={cx("mb-2", {
        "opacity-50 text-decoration-line-through": isRemoved,
      })}
    >
      <b className="col-2 text-end pt-1">{name}</b>
      {showDiff && (
        <Col xs={4}>
          <div className="EditDiff bg-danger">{oldValue}</div>
        </Col>
      )}
      <Col xs={showDiff ? 4 : 8}>
        <div className={cx("EditDiff", { "bg-success": showDiff })}>
          {newValue}
        </div>
      </Col>
      <Col xs={2} className="text-end">
        {!isRemoved && (
          <Button
            variant="danger"
            size="sm"
            onClick={() => clearField(field)}
            title={`Remove ${name} change`}
          >
            <Icon icon={faXmark} />
          </Button>
        )}
        {isRemoved && (
          <Button
            variant="secondary"
            size="sm"
            onClick={() => restoreField(field)}
            title={`Restore ${name} change`}
          >
            <Icon icon={faUndo} />
          </Button>
        )}
      </Col>
    </Row>
  );
};

export default AmendableChangeRow;
